module.exports = __webpack_public_path__ + "img/time.98e18f4d.png";